import { Profile } from "@app/user/account/manage/Profile";

export {
  Profile,
};
